import React, { Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  UpdateConditionalFieldValue,
  UpdateDisableButtonState,
  updateHideButton,
} from '../../../ReduxImpl/actions/index'
import { IReduxState } from '../../../ReduxImpl/reducers/index'
import {
  Label,
  ListFieldProps,
  FieldChangeCallback,
} from '@sitecore-jss/sitecore-jss-react-forms'
import { ValueFormField } from '@sitecore-jss/sitecore-jss-forms'

const RadioButtonListField: React.FunctionComponent<ListFieldProps> = (
  props
) => {
  const {
    field,
    field: {
      model: { items },
    },
    value,
    onChange,
    tracker,
    errors,
    fieldValidationErrorsComponent,
  } = props

  const dispatch = useDispatch()

  const fieldValues = useSelector((state: IReduxState) => state.fieldValues)
  const hideButton = useSelector((state: IReduxState) => state.hideButton)

  const FieldValidationErrors = fieldValidationErrorsComponent

  return (
    <Fragment>
      <Label {...props} />

      <div className="sitecore-jss-form--radiobuttonAlign">
        {items.map((item, index) => (
          <div className="sitecore-jss-form--radiobutton" key={index}>
            <label key={item.itemId}>
              <input
                type="radio"
                className={field.model.cssClass}
                id={field.valueField.id + index}
                name={field.valueField.name}
                value={item.value}
                checked={value.some((v) => v === item.value)}
                onChange={(e) =>
                  handleOnChange(
                    field,
                    e.target.value,
                    onChange,
                    fieldValues,
                    hideButton,
                    dispatch
                  )
                }
                onFocus={() => tracker.onFocusField(field, value)}
                onBlur={() => tracker.onBlurField(field, value, errors)}
              />

              {item.text}
            </label>
          </div>
        ))}
      </div>

      {FieldValidationErrors && <FieldValidationErrors {...props} />}
    </Fragment>
  )
}

/**
 * @param {ValueFormField} field
 * @param {string} newValue
 * @param {FieldChangeCallback} callback
 */
function handleOnChange(
  field: ValueFormField,
  newValue: string,
  callback: FieldChangeCallback,
  fieldValues: any,
  hideButton: boolean,
  dispatch: any
) {
  let valid = true
  const errorMessages: string[] = []

  fieldValues[(field.model['conditionSettings'] as any).fieldKey] = newValue
  dispatch(UpdateConditionalFieldValue(fieldValues))

  // custom client validation logic here
  if (field.model.required && !newValue) {
    valid = false
    errorMessages.push(`${field.model.title} is required`)
  }

  if (field.model.required && newValue === 'Non accetto') {
    dispatch(updateHideButton(hideButton))
  }
  if (field.model.required && newValue === 'Accetto') {
    dispatch(updateHideButton(hideButton))
  }

  if (field.model.required && newValue === 'I do not agree') {
    dispatch(UpdateDisableButtonState(true));
  }

  if (field.model.required && newValue === 'I agree') {
    dispatch(UpdateDisableButtonState(false));
  }

  callback(field.valueField.name, [newValue], valid, errorMessages)
}

export default RadioButtonListField
